const fe = {
	enrolment: {
		title: "Enrolment Form:",
		organisation_title: "Organisation Information",
		personal_title: "Personal Information",
		details: "Details",
		course_details: "Course Details",
		company_information: "Company information",
		course_type: "Course Type",
		start_datetime: "Start Date/Time",
		end_datetime: "End Date/Time",
		visiting_address: "Visiting Address",
		invoice_address: "Invoice Address",
		participants: "Participants",
		p_course_id: "Course",
		p_first_name: "First Name",
		p_last_name: "Last Name",
		p_email: "Email",
		p_mobile: "Mobile",
		p_date_of_birth: "Date of Birth",
		p_address_street: "Street",
		p_address_city: "City",
		p_address_state: "State",
		p_address_zip: "Zip",
		p_address_country: "Country",
		o_vat: "VAT",
		o_name: "Company",
		o_course_id: "Course",
		o_first_name: "Requestor First Name",
		o_last_name: "Requestor Last Name",
		o_email: "Requestor Email",
		o_reference: "Reference/PO",
		o_customer_number: "Customer Number",
		o_address_street: "Street",
		o_address_city: "City",
		o_address_state: "State",
		o_address_zip: "Zip",
		o_address_country: "Country",
		invoice_email: "Invoice Email",
		comment: "Comment",
		submit: "Submit",
		submit_interest: "Submit",
		pay_and_enrol: "Pay and enroll",
		no_of_participants: "Number of Participants",
		enrolment_success: "Enrollment was successful. Confirmation email is sent.",
		enrolment_success_noemailsms: "Successful enrolment",
		enrolment_success_reservation: "Success. Confirmation is emailed to you.",
		enrolment_success_klarna: "Paid with Klarna on {date}",
		enrolment_error: "Failed to enrol. Please contact administrator.",
		enrolment_duplicate: "Enrolment failed. {names} has already enrolled to this course.",
		include: "Includes:",
		additionals: "Additionals:",
		select_course_types: "Select Course Types (Min: 1)",
		price: "Price",
		price_additional: "Additional",
		price_total: "Total",
		all_seats_taken: "All course seats are taken. It is not possible to enroll.,  ",
		course_full_register: "Course is full, but you can still register your request",
		course_not_published_title: "Course Error",
		course_not_published: "This link to enrollment has expired",
		privacy_policy_title: "Privacy Notice",
		privacy_consent_to: "I consent to our",
		privacy_notice: "Privacy Notice",
		privacy_close: "Close",
		enrol: "Enrol",
		enrolment_cancel_ok: "Enrolment successfully cancelled.",
		enrolment_cancel_error: "Failed to cancel enrolment.",
		interest_title: "Interest registration form",
		interest_description: "Please select one or multiple types you are interested in. We will notify you when courses are available.",
		interest_select_courstypes: "Select one or multiple course types",
		interest_enrol_confirm: "Do you want to keep this person on the Interested list?",
		interest_comment_required: "No course type selected. Please fill out comment field.",
		enrolment_to: "Enrollement to",
		same_choices_for_all: "Same choice for all",
		select_organisation: "Organisation / Group",
		select_personal: "Personal",
		date_and_place: "Date and place",
		participants_unknown: "Participants are unknown. Reserve a spot.",
		delete_reservation: "Would you like to delete the reservation?",
	},
	course: {
		interest_form: "Interest form",
		upcoming_full_confirm: "The course is full. You can select one of the following",
	},
};
export default fe;